<template>
  <v-container fluid style="height: 100%; min-height: 580px;" class="search-box">
    <v-layout>
      <v-flex xs12>
        <DashboardSearch v-on:search="search" />
      </v-flex>
    </v-layout>

    <v-layout row wrap py-2 pb-0>
      <v-layout row wrap ma-0 py-4 justify-start>
        <v-flex class="col-5" :class="[{ 'col-12': $vuetify.breakpoint.smAndDown }]">
          <p class="font-weight-medium my-0 ml-4">อุบัติเหตุบนโครงข่ายทางน้ำ</p>
          <TodayDamage :searchParams="searchParams" />
        </v-flex>
        <v-flex class="col-1"></v-flex>
        <v-flex class="col-5" :class="[{ 'col-12': $vuetify.breakpoint.smAndDown }]">
          <p class="font-weight-medium my-0 ml-4">อุบัติเหตุแยกตามสถานที่เกิดเหตุ</p>
          <TodayWater :searchParams="searchParams" />
        </v-flex>
      </v-layout>

      <v-layout row ma-0 py-2 class="brightgrey-bg" v-if="startDate && endDate">
        <v-flex xs12 style="display: flex;" class="justify-space-between">
          <p class="font-weight-medium my-0 ml-4">
            วันที่ {{ showDate(startDate) }} ถึง {{ showDate(endDate) }}
          </p>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import DashboardSearch from '../global/dashboard/DashboardSearch.vue';
import TodayDamage from './TodayDamage.vue';
import TodayWater from './TodayWater.vue';

export default {
  name: 'Search',
  components: {
    DashboardSearch,
    TodayDamage,
    TodayWater
  },
  data: () => ({
    on: false,
    dialog: false,
    icon: {
      die_icon: require('@/assets/images/ic_die.png')
    },
    searchType: '',
    startDate: '',
    endDate: '',
    reportDate: '',
    reportTime: '',
    yearSelect: '',
    eventSelect: '',
    provinceSelect: '',
    vehicleSelect: '',
    yearItems: [],
    eventItems: [],
    provinceItems: [],
    vehicleItems: [],
    searchParams: {}
  }),
  created() {
    this.getYearLists();
    this.getEventLists();
    this.getVehicleLists();
    this.getProvinceLists();
  },
  mounted() {},
  methods: {
    getYearLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/budget_year`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.yearItems = response.data.data;
            if (scope.yearItems.length > 0) scope.yearItems.unshift('เลือกทุกปี');
          }
        })
        .catch(function(error) {
          scope.yearItems = [];
          console.log(error);
        });
    },
    getEventLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/event`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.eventItems = response.data.data;
            if (scope.eventItems.length > 0)
              scope.eventItems.unshift({ id: 0, name: 'เลือกทุกเทศกาล' });
          }
        })
        .catch(function(error) {
          scope.eventItems = [];
          console.log(error);
        });
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            if (scope.provinceItems.length > 0)
              scope.provinceItems.unshift({ id: 0, name: 'เลือกทุกจังหวัด' });
          }
        })
        .catch(function(error) {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getVehicleLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/vehicle`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.vehicleItems = response.data.data;
            if (scope.vehicleItems.length > 0)
              scope.vehicleItems.unshift({ id: 0, name: 'เลือกทุกยานพาหนะ' });
          }
        })
        .catch(function(error) {
          scope.vehicleItems = [];
          console.log(error);
        });
    },
    alert() {
      alert('ค้นหา');
    },
    routeToMap() {
      this.$router.push({ name: 'map' });
    },
    search(searchParams) {
      // if (this.searchType == 'tabPeriod') {
      //   this.$emit('getSearchCondition', {
      //     search: this.searchType,
      //     start_date: this.startDate,
      //     end_date: this.endDate,
      //     report_date: this.reportDate,
      //     report_time: this.reportTime,
      //     province: this.provinceSelect,
      //     vehicle: this.vehicleSelect
      //   });
      // } else {
      //   this.$emit('getSearchCondition', {
      //     search: this.searchType,
      //     year: this.yearSelect,
      //     event: this.eventSelect
      //   });
      // }
      // console.log(searchParams);
      this.searchParams = searchParams;
      this.$emit('getSearchCondition', searchParams);
    }
  },
  watch: {
    searchType(value) {
      this.search();
    }
  },
  computed: {
    filter() {
      return this.searchFilter;
    },
    showDate(date) {
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.v-tab {
  // background-color: white;
  color: #131313;
}

.v-tab.v-tab--active {
  // background-color: #ba4438;
  color: #ba4438;
  border-bottom: 1px solid #ba4438;
}

.search-box {
  // min-height: 320px;
  position: relative;
  // max-height: 100%;
}

.detail {
  // background: var(--v-brightgrey-base);
  position: absolute;
  bottom: 0;
  width: 100%;
  margin: 0;
}

.v-text-field {
  height: 40px;
}

.container {
  padding: 0;
  background-color: white;
}

.card-border {
  margin-top: 4px;
}

.v-text-field {
  height: 40px;
}

.headline {
  color: #ba4438;
  border-bottom: 1px solid #ededed;
  p {
    font-size: 18px;
  }
}

.v-card-title {
  border-bottom: 1px solid #cfcfcf;
  justify-content: space-between;
  font-size: 18px;
}

.v-card__text {
  padding: 20px !important;
}

.v-dialog__container {
  display: none !important;
}

.search-desktop {
  position: absolute;
  bottom: 0;
  margin-bottom: 4px;
}

.brightgrey-bg {
  background-color: var(--v-brightgrey-base);
}
</style>
